export default __webpack_public_path__ + "static/media/diplomIcon.69b2de7f.svg";